import angular from 'angular'

const listPage = require('./view/list.html')
const infoPage = require('./view/info.html')
const detailPage = require('./view/detail.html')
const lockRecordList = require('./view/lockRecordList.html')
const listCtrl = require('./list')
const infoCtrl = require('./info')
const detailCtrl = require('./detail')
const lockRecordListCtrl = require('./lockRecordListCtrl')

function configRouter($stateProvider) {
    $stateProvider.state('system.basedata.taxAccount', {
        url: '/taxAccount',
        abstract: true,
        template: '<div ui-view></div>',
        default: 'system.basedata.taxAccount.list',
        title: '税务账号管理',
    })
    $stateProvider.state('system.basedata.taxAccount.list', {
        url: '/list',
        template: listPage,
        controller: 'taxAccountListCtrl',
    })
    $stateProvider.state('system.basedata.taxAccount.add', {
        url: '/add',
        template: infoPage,
        controller: 'taxAccountInfoCtrl',
        title: '新增',
    })
    $stateProvider.state('system.basedata.taxAccount.edit', {
        url: '/edit/:drawerId/:isOriginalDrawer',
        template: infoPage,
        controller: 'taxAccountInfoCtrl',
        title: '编辑',
    })
    $stateProvider.state('system.basedata.taxAccount.detail', {
        url: '/detail/:drawerId',
        template: detailPage,
        controller: 'taxAccountDetailCtrl',
        title: '详情',
    })
    $stateProvider.state('system.basedata.taxAccount.lockRecordList', {
        url: '/lockRecordList',
        template: lockRecordList,
        controller: 'lockRecordListCtrl',
        title: '税务账号锁定记录',
    })
}

export default angular
    .module('system.basedata.taxAccount', [])
    .config(['$stateProvider', configRouter])
    .controller('taxAccountListCtrl', listCtrl.default)
    .controller('taxAccountDetailCtrl', detailCtrl.default)
    .controller('taxAccountInfoCtrl', infoCtrl.default)
    .controller('lockRecordListCtrl', lockRecordListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxAccount/index.js